function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import { showToast } from 'vant';
import 'vant/es/toast/style';
import 'vant/es/overlay/style';
import 'vant/es/loading/style';
import '../../qipao_bridge';
import { PostsApi } from '../../api';
import circlePostInAppOpen from '../../mixins/circlePostInAppOpen';
import wechatJsSdkMixin from '../../mixins/wechatJsSdkMixin';
import CirclePostOpenAppConfirm from '../../components/global/CirclePostOpenAppConfirm.vue';
import WechatOpenLaunchApp from '../../components/global/WechatOpenLaunchApp.vue';
var DEFAULT_POST_ID = '';
export default {
  name: 'PostImageDetail',
  components: {
    CirclePostOpenAppConfirm: CirclePostOpenAppConfirm,
    WechatOpenLaunchApp: WechatOpenLaunchApp
  },
  mixins: [wechatJsSdkMixin, circlePostInAppOpen],
  data: function data() {
    return {
      postId: DEFAULT_POST_ID,
      loading: false,
      data: null,
      /** @type {1} 图片帖子 */
      circlePostType: 1
    };
  },
  computed: {
    /**
     * 供 `wx-open-launch-app` 的 extinfo，与端上 OpenSDK 约定解析
     * @returns {string}
     */
    wxCirclePostExtinfo: function wxCirclePostExtinfo() {
      return JSON.stringify({
        path: 'circle/post',
        post_id: this.postId,
        user_code: this.userCode,
        type: this.circlePostType
      });
    },
    user: function user() {
      var _this$data, _this$data2;
      return ((_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.user_info) || ((_this$data2 = this.data) === null || _this$data2 === void 0 ? void 0 : _this$data2.userInfo) || {};
    },
    avatarUrl: function avatarUrl() {
      var _this$user, _this$user2;
      return this.sanitizeUrl(((_this$user = this.user) === null || _this$user === void 0 ? void 0 : _this$user.user_head_url) || ((_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : _this$user2.userHeadUrl) || '');
    },
    userName: function userName() {
      var _this$user3, _this$user4;
      return ((_this$user3 = this.user) === null || _this$user3 === void 0 ? void 0 : _this$user3.user_name) || ((_this$user4 = this.user) === null || _this$user4 === void 0 ? void 0 : _this$user4.userName) || '用户';
    },
    userSub: function userSub() {
      var _this$data3, _this$data4, _this$user5, _this$user6;
      var time = ((_this$data3 = this.data) === null || _this$data3 === void 0 ? void 0 : _this$data3.published_at) || ((_this$data4 = this.data) === null || _this$data4 === void 0 ? void 0 : _this$data4.publishedAt) || '';
      var ip = ((_this$user5 = this.user) === null || _this$user5 === void 0 ? void 0 : _this$user5.ip_address) || ((_this$user6 = this.user) === null || _this$user6 === void 0 ? void 0 : _this$user6.ip) || '';
      var left = time ? '1小时前' : '';
      var right = ip ? "IP\u5C5E\u5730\uFF1A".concat(ip) : '';
      return [left, right].filter(Boolean).join('   ') || ' ';
    },
    followedText: function followedText() {
      var _ref, _ref2, _this$data$followed_s, _this$data5, _this$user7, _this$data6;
      var followed = (_ref = (_ref2 = (_this$data$followed_s = (_this$data5 = this.data) === null || _this$data5 === void 0 ? void 0 : _this$data5.followed_status) !== null && _this$data$followed_s !== void 0 ? _this$data$followed_s : (_this$user7 = this.user) === null || _this$user7 === void 0 ? void 0 : _this$user7.followed_status) !== null && _ref2 !== void 0 ? _ref2 : (_this$data6 = this.data) === null || _this$data6 === void 0 ? void 0 : _this$data6.followedStatus) !== null && _ref !== void 0 ? _ref : false;
      return followed ? '已关注' : '关注';
    },
    titleText: function titleText() {
      var _this$data7;
      return ((_this$data7 = this.data) === null || _this$data7 === void 0 ? void 0 : _this$data7.title) || ' ';
    },
    descText: function descText() {
      var _this$data8, _this$data9;
      return ((_this$data8 = this.data) === null || _this$data8 === void 0 ? void 0 : _this$data8.description) || ((_this$data9 = this.data) === null || _this$data9 === void 0 ? void 0 : _this$data9.desc) || ' ';
    },
    coverUrl: function coverUrl() {
      var _this$data0, _this$data1;
      return this.sanitizeUrl(((_this$data0 = this.data) === null || _this$data0 === void 0 ? void 0 : _this$data0.cover_url) || ((_this$data1 = this.data) === null || _this$data1 === void 0 ? void 0 : _this$data1.coverUrl) || '');
    }
  },
  methods: {
    sanitizeUrl: function sanitizeUrl(value) {
      return String(value || '').replace(/`/g, '').trim().replace(/^['"]+|['"]+$/g, '');
    },
    resolvePostId: function resolvePostId() {
      var _this$$route, _this$$route$params, _this$$route2, _this$$route2$query, _this$$route3, _this$$route3$query;
      var fromParams = (_this$$route = this.$route) === null || _this$$route === void 0 ? void 0 : (_this$$route$params = _this$$route.params) === null || _this$$route$params === void 0 ? void 0 : _this$$route$params.postId;
      var fromQuery = ((_this$$route2 = this.$route) === null || _this$$route2 === void 0 ? void 0 : (_this$$route2$query = _this$$route2.query) === null || _this$$route2$query === void 0 ? void 0 : _this$$route2$query.post_id) || ((_this$$route3 = this.$route) === null || _this$$route3 === void 0 ? void 0 : (_this$$route3$query = _this$$route3.query) === null || _this$$route3$query === void 0 ? void 0 : _this$$route3$query.postId);
      var fromUrl = this.getUrlQueryValue('post_id') || this.getUrlQueryValue('postId');
      var id = fromParams || fromQuery || fromUrl || DEFAULT_POST_ID;
      this.postId = id ? String(id) : '';
    },
    fetchDetail: function fetchDetail() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _this.loading = true;
              _context.p = 1;
              _context.n = 2;
              return PostsApi.newPostInfo({
                postId: _this.postId
              });
            case 2:
              res = _context.v;
              _this.data = (res === null || res === void 0 ? void 0 : res.data) || (res === null || res === void 0 ? void 0 : res.post) || res || null;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              showToast((_t === null || _t === void 0 ? void 0 : _t.message) || '加载失败');
            case 4:
              _context.p = 4;
              _this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }))();
    }
  },
  mounted: function mounted() {
    this.resolvePostId();
    this.resolveUserCode();
    if (!this.postId) {
      showToast('缺少 post_id');
      return;
    }
    this.fetchDetail();
  }
};